export enum AverSound {
  ON = "on",
  OFF = "off",
}

export const defaultAverSound = AverSound.ON;
